import { Container, Typography, Card, CardContent, Box } from "@mui/material";
import Footer from "../components/Footer";

const PrivacyPolicy = () => {
  const WEBSITE = "Phoenix Play Zone";

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#1f2937",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#1f2937",
          py: 4,
          // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        <Container maxWidth="md" sx={{ textAlign: "center" }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontWeight: "bold", color: "white" }}
          >
            Privacy Policy
          </Typography>
          <Typography variant="subtitle1" color="white">
            Explore our premium courts for futsal, badminton, and more.
          </Typography>
        </Container>
      </Box>
      <Box sx={{ flexGrow: 1, backgroundColor: "#1f2937" }}>
        <Container maxWidth="md" className="px-5">
          <Card className="shadow-lg rounded-2xl" sx={{ backgroundColor: "#1f2937", color: 'white' }}>
            <CardContent className="p-6">
              <Typography variant="body1" className="mb-4">
                At {WEBSITE}, we are committed to protecting the privacy and
                security of our customers' personal information. This Privacy
                Policy outlines how we collect, use, and safeguard your
                information when you visit or make a booking on our website.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Information We Collect
              </Typography>
              <Typography variant="body1" className="mb-4">
                When you use our website, we may collect personal identification
                information such as your name, email address, and phone number,
                provided voluntarily during the booking process. Additionally,
                we may collect browsing information like your IP address and
                device details through cookies and similar technologies.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Use of Information
              </Typography>
              <Typography variant="body1" className="mb-4">
                We use the collected information to:
                <ul className="list-disc pl-6">
                  <li>Process and confirm your bookings.</li>
                  <li>
                    Communicate with you regarding your bookings and provide
                    support.
                  </li>
                  <li>Improve our website and services.</li>
                  <li>Detect and prevent fraud or unauthorized activities.</li>
                </ul>
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Information Sharing
              </Typography>
              <Typography variant="body1" className="mb-4">
                We do not sell or trade your personal information. However, we
                may share it with trusted third-party service providers
                assisting with website operations, payment processing, and legal
                requirements if necessary.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Data Security
              </Typography>
              <Typography variant="body1" className="mb-4">
                We implement industry-standard security measures to protect your
                data. However, no method of electronic transmission or storage
                is 100% secure.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Cookies and Tracking Technologies
              </Typography>
              <Typography variant="body1" className="mb-4">
                Our website uses cookies to enhance user experience and analyze
                traffic. You can manage your cookie settings through your
                browser preferences.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Changes to the Privacy Policy
              </Typography>
              <Typography variant="body1" className="mb-4">
                We may update this Privacy Policy periodically. Please review
                this page regularly to stay informed.
              </Typography>
              <br/>
              <Typography variant="h6" className="mt-6 font-semibold" sx={{ color: '#e5e7eb', textDecoration: 'underline'}}>
                Contact Us
              </Typography>
              <Typography variant="body1">
                If you have any questions regarding our Privacy Policy, please
                contact our support team.
              </Typography>
            </CardContent>
          </Card>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicy;
